import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect, useMemo, useRef } from "react";
import MetaTags from "react-meta-tags";
import { useHistory, NavLink } from "react-router-dom";
// import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { connect } from "react-redux";
import { Pagination, Row, Col } from "antd";
import { getSortedProducts } from "../../helpers/product";
import LayoutOne from "../../layouts/LayoutOne";
// import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import ShopSidebar from "../../wrappers/product/ShopSidebar";
import ShopTopbar from "../../wrappers/product/ShopTopbar";
import ShopProducts from "../../wrappers/product/ShopProducts";
import { fetchProducts, searchProduct } from "../../redux/actions/productActions";
import { findCategoryBySlug, getSearchKey, search_key_presist } from "../constant/utils";
import { store } from "../..";
import { capitalizeWords, searchFilter, setSearchTagKeys } from "../constant/Constants";
import "./style.css";
import { debounce } from "lodash";
import { isEqual } from "lodash";
import { useMainUIContext } from "../../UIContext";
import { RightOutlined } from '@ant-design/icons';

let _page = 0;
let prevLocation = ""
const ShopGridStandard = ({
  categoryTreeData,
  brandsData,
  location,
  products,
  pageSize,
  settingData,
  loading,
  productSearch,
  templateStyles
}) => {
  const index = 1
  const history = useHistory();
  const categorySlug = history.location.pathname.split("/shop/")[index];
  const pageNumber = history.location.search.split("?page=")[index];
  const productSearchEnter = localStorage.getItem("shop_search_filters")
  const persistedFilters = productSearchEnter ? JSON.parse(localStorage.getItem("shop_search_filters")) : "";

  function isInputSelected(inputElement) {
    if (inputElement.selectionStart !== inputElement.selectionEnd) {

      return true;
    }
    return false;
  }

  const mainUIContext = useMainUIContext();
  const mainUIProps = useMemo(() => {
    return {
      searchKey: mainUIContext.searchKey,
      setSearchKey: mainUIContext.setSearchKey,
      enterSearchIcon: mainUIContext.enterSearchIcon, 
      setEnterSearchIcon: mainUIContext.setEnterSearchIcon,
      viewAllProducts:mainUIContext.viewAllProducts,
      setViewAllProducts:mainUIContext.setViewAllProducts,
      filters:mainUIContext.filters,
      setFilter:mainUIContext.setFilter,
      searchTag:mainUIContext.searchTag,
      setSearchTag:mainUIContext.setSearchTag,
      selectedBrands:mainUIContext.selectedBrands,
      setSelectedBrands:mainUIContext.setSelectedBrands,
      selectedCatHeader:mainUIContext.selectedCatHeader,
      setSelectedCatHeader:mainUIContext.setSelectedCatHeader
    };
  }, [mainUIContext]);
  const { searchKey, setSearchKey, enterSearchIcon, setEnterSearchIcon, viewAllProducts, 
    setViewAllProducts, setFilter, filters, searchTag, setSearchTag,setSelectedBrands,selectedBrands,selectedCatHeader
   } = mainUIProps;

  const updateSearchTag = () => {
    setSearchTag(prev => ({
        ...prev,
        category_ids: null
    }));
};

  useEffect(() => {
    const inputElement = document.getElementById('input-header-search');
    if (viewAllProducts ) {
      updateSearchTag()
      localStorage.setItem("shop_search_filters", "");
        localStorage.setItem("pageNumberPreserve", index);
        setCurrentPage(index)
        history.location.pathname=(`/shop?search=${inputElement.value}`);
        setFilter((prev)=>({...prev, searchKeyForShopPage:"inputElement.value", brand_ids:"", category_ids:"",
          is_featured:null,is_hot_seller:null,is_new_arrival:null,
        }))
        localStorage.setItem("brandsPreserve", "");
    }
  }, [viewAllProducts]);
  
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Enter' && event.target?.value?.length) {
        history.push(`/shop?search=${inputElement.value}`);
        setSelectedBrands("")
        if (productSearchEnter?.search_filter?.category_ids) {
          productSearchEnter.search_filter.category_ids = null;
          productSearchEnter.search_filter.brand_ids = null;
          }
          localStorage.setItem("shop_search_filters", JSON.stringify(productSearchEnter));

        updateSearchTag()    
        localStorage.setItem("shop_search_filters", null);
        localStorage.setItem("pageNumberPreserve", index);
        setCurrentPage(index)
        setFilter((prev) => ({ ...prev, searchKeyForShopPage: inputElement.value, brand_ids: "", category_ids: "",
          is_featured:null,is_hot_seller:null,is_new_arrival:null,
         }))
         localStorage.setItem("brandsPreserve", "");
      }
      if (event.key == "Backspace" && (isInputSelected(inputElement) || event?.target?.value?.length==index)){
        const newUrl = new URL(window.location.href);
        updateSearchTag()
        newUrl.searchParams.delete('search');
        window.history.replaceState({}, '', newUrl.toString());
        setSearchKey("")
        setFilter((prev) => ({ ...prev, searchKeyForShopPage: "", brand_ids: "", category_ids: "",	
          is_featured:null,is_hot_seller:null,is_new_arrival:null,	
         }))
      }
    };

    const onSearchIconClick = () => {
      if (inputElement.value) {
        handleKeyDown({ key: 'Enter', target: { value: inputElement.value } })
      }
    }

    const inputSearchIcon = document.getElementById('top-bar-search-icon');
    const inputElement = document.getElementById('input-header-search');
    if (inputElement) {
      inputElement.addEventListener('keydown', handleKeyDown);
    }

    if (inputSearchIcon) {
      inputSearchIcon.addEventListener('click', onSearchIconClick);
    }

    return () => {
      if (inputElement) {
        inputElement.removeEventListener('keydown', handleKeyDown);
        inputElement.value = ""
      }
    };
  }, []);

  const [layout, setLayout] = useState("grid two-column");
  const getSidebarFilterState = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 850) {
      return "inActive";
    }
    return (categorySlug || persistedFilters) ? "active" : "inActive";
  };

  const [sidebarFilter, setSidebarFilter] = useState(getSidebarFilterState);
  const [sortType, setSortType] = useState("");
  const [sortValue, setSortValue] = useState("");
  const [filterSortType, setFilterSortType] = useState("");
  const [filterSortValue, setFilterSortValue] = useState("");
  const [offset, setOffset] = useState(0);
  const [description, setDescription] = useState('');
  const [scrollToTop, setScrollToTop] = useState(false);
  const filtersRef = useRef();

  useEffect(() => {
    if (scrollToTop) {
      window.scrollTo(0, 0);
      setScrollToTop(false)
    }
  }, [scrollToTop]);

  const handleDescriptionChange = (newDescription) => {
    setDescription(newDescription);
  };

  const getQueryParam = (param) => {
    const queryParams = new URLSearchParams(location.search);
    return queryParams.get(param);
  };

  useEffect(() => {
    getQueryParam("search");
  }, [location.search]);

  const [currentPage, setCurrentPage] = useState(1); // Current page number
  const [itemsPerPage, setItemsPerPage] = useState(100); // Number of items per page
  const [totalCount, setTotalCount] = useState(0); // Total number of items

  const handlePaginationChange = (newPage, newItemsPerPage) => {
    localStorage.setItem("pageNumberPreserve", newPage);
    try {
      setScrollToTop(true);
    } catch (err) {
    }
    if (newPage) {
      history.push(`/shop?page=${newPage}`);
      setCurrentPage(newPage);
    } else {
      setCurrentPage(currentPage);
    }
  };

  const [currentData, setCurrentData] = useState([]);
  const [sortedProducts, setSortedProducts] = useState([]);
  const { pathname } = location;

  const getLayout = (layout) => {
    setLayout(layout);
  };

  const getItemsPerPage = (items) => {
    setItemsPerPage(items);
  };

  const getSidebarFilter = (filter) => {
    setSidebarFilter(filter);
  };

  const getSortParams = (sortType, sortValue) => {
    setSortType(sortType);
    setSortValue(sortValue);
  };

  const getFilterSortParams = (sortType, sortValue) => {
    if (sortValue == "variantsGroup") {
      let params = {
        ...filters,
        page_size: itemsPerPage,
        channel_id: settingData.channel_id,
        is_default_variant: 1,
      };
      store.dispatch(fetchProducts(params, 1, setTotalCount))
      return
    }

    else if (sortValue !== "variantsGroup") {
      let params = {
        ...filters,
        page_size: itemsPerPage,
        channel_id: settingData.channel_id,
        tobacco_status: 1,
      };

      store.dispatch(fetchProducts(params, 1, setTotalCount))
      setFilterSortType(sortType);
      setFilterSortValue(sortValue);
    }
  };

  useEffect(() => {
    let sortedProducts = getSortedProducts(products, sortType, sortValue);
    const filterSortedProducts = getSortedProducts(
      sortedProducts,
      filterSortType,
      filterSortValue
    );
    sortedProducts = filterSortedProducts;
    setSortedProducts(sortedProducts);
    setCurrentData(sortedProducts);
  }, [offset, products, sortType, sortValue, filterSortType, filterSortValue]);

  useEffect(() => {
    if (enterSearchIcon) {
      getProductsList(index);
    }

    const unlisten = history.listen((location, action) => {
      if (action === 'POP') { // 'POP' means the user navigated backward or forward in history
        setSearchKey("");
        localStorage.setItem("pageNumberPreserve", null);
      }
    });

    return () => {
      unlisten(); // Cleanup the listener on component unmount
      setTimeout(() => {
        if (pageNumber && !enterSearchIcon) {
          setSearchKey("");
          localStorage.setItem("pageNumberPreserve", null);
        }
      }, 0);
    };
  }, [history, enterSearchIcon, pageNumber]);

  function flattenCategories(categories) {
    let result = [];
    categories?.length && categories.forEach(category => {
      result.push({ id: category.id, name: category.name });
      if (category.children && category.children?.length > 0) {
        result = result.concat(flattenCategories(category.children));
      }
    });
    return result;
  }

  function mapCategoryTreeData() {
    const parsedCategories = flattenCategories(categoryTreeData)
    const catName = parsedCategories?.length && parsedCategories
      ?.filter(category => persistedFilters?.search_filter?.category_ids == category?.id)
      .map(category => category?.name);
    return capitalizeWords(catName)
  }

  const checkStringNullValue = (value) => {
    if ([null, "null"].includes(value)) {
      return null
    }
    return value
  }


  const getProductsList = (Page = undefined) => { 
    if (!Page) {
      setCurrentPage(index);
      _page = 1;
    }
    if (!isEqual(filters, filtersRef.current)) {
      let category = undefined;
      let brand = undefined;
      let shopSearchFilters = filters;
      if (history.location.pathname.includes("/shop") && categoryTreeData && brandsData) {
        const slug = history.location.pathname.split("/shop/")[index];
        const queryString = history.location.search;
        const urlParams = new URLSearchParams(queryString);
        const filterBrand = urlParams.get('filter_brand');
        const filterOther = urlParams.get('filter_other');
        const searchAll = urlParams.get('search');
        if (categoryTreeData.length > 0) {
          category = findCategoryBySlug(categoryTreeData, slug);
        }
        if (brandsData.length > 0) {
          brand = brandsData.find((brand) => brand.slug === filterBrand);
        }
        const search = history.location?.search
        if (!slug && !filterBrand && !filterOther && persistedFilters && !search && !isEqual(persistedFilters.search_filter, shopSearchFilters)) {
          shopSearchFilters = persistedFilters.search_filter;
        //   if (!persistedFilters.slug) {
        //     if (shopSearchFilters.brand_ids) {
        //         shopSearchFilters.brand_ids = "";
        //     }
        //     persistedFilters.slug = '';
        // }
          setFilter(shopSearchFilters);
          filtersRef.current = shopSearchFilters;
          return;
          
        } else if (!searchAll) {
          if (shopSearchFilters?.category_ids) {
            setSearchTag(prev => ({
              ...prev,
              category_ids: shopSearchFilters?.category_ids,
            }));
      }
          if (category) {
            shopSearchFilters = { ...filters, category_ids: category.id};
            setFilter(prev => ({
              ...prev,
              category_ids: shopSearchFilters?.category_ids,
              brand_ids:""
            }));
            localStorage.setItem("shop_search_filters", JSON.stringify({ search_filter: shopSearchFilters, slug: category.slug, seo_meta_data: category?.seo_metadata }));
            filtersRef.current = shopSearchFilters;
            setSearchTag(prev => ({
              ...prev,
              category_ids: category.id
            }));
          }
          if (filterOther){
            let shopSearchFilters = { ...filters };
          if (["is_new_arrival", "is_hot_seller", "is_featured"].includes(filterOther)) {
              shopSearchFilters = {
                  ...shopSearchFilters,
                  is_new_arrival: filterOther === "is_new_arrival" ? 1 : null,
                  is_hot_seller: filterOther === "is_hot_seller" ? 1 :null,
                  is_featured: filterOther === "is_featured" ? 1 : null
              };
              setFilter(shopSearchFilters);
              localStorage.setItem("shop_search_filters", JSON.stringify({ search_filter: shopSearchFilters }));
              filtersRef.current = shopSearchFilters;
          }
        }
        if (brand) {
          shopSearchFilters = { ...filters, brand_ids: brand.id };
          setFilter(shopSearchFilters);
          localStorage.setItem("brandsPreserve", JSON.stringify(shopSearchFilters?.brand_ids))
          localStorage.setItem("shop_search_filters", JSON.stringify({ search_filter: shopSearchFilters, slug: brand.slug, seo_meta_data: null }));
          filtersRef.current = shopSearchFilters;
        }}
      }
    }
    const getBrands = localStorage.getItem("brandsPreserve")
    let params = {
      ...filters,
      page_size: itemsPerPage,
      page: checkStringNullValue(localStorage.getItem("pageNumberPreserve")) || pageNumber || Page || _page,
      channel_id: settingData.channel_id,
      tobacco_status: 1,
      search_key: searchKey || getSearchKey(),
      default_variant : 1,
      brand_ids: selectedCatHeader ? (filters?.brand_ids && Array.isArray(filters.brand_ids)) 
      ? filters.brand_ids.join(",") 
      : getBrands || "" : ""
        };

    setEnterSearchIcon(false)
    setViewAllProducts(false)
    
    store.dispatch(fetchProducts(params, Page, setTotalCount));
  };

  useMemo(() => {
    if (categoryTreeData && brandsData) {
      getProductsList(currentPage);
    }
  }, [itemsPerPage, filters, filters?.searchKeyForShopPage, pageNumber, categoryTreeData, brandsData, history.location.search]);

  return (
    <Fragment>
      <MetaTags>
        <title>{productSearchEnter ? JSON.parse(localStorage.getItem("shop_search_filters"))?.seo_meta_data?.title : settingData?.shop_meta_title ? settingData?.shop_meta_title : "Shop"}</title>
        <meta
          name="description"
          content={productSearchEnter ? JSON.parse(localStorage.getItem("shop_search_filters"))?.seo_meta_data?.description : settingData?.shop_meta_description ? settingData?.shop_meta_description : `Shop page of ${settingData?.ecom_title}.`}
        />
      </MetaTags>
      <LayoutOne headerTop="visible" templateStyles={templateStyles}>
        <div className="shop-area pt-lg-20 pb-170">
          <div className="container-fluid" style={{ marginTop: "40px" }}>
            <div className="breadcrums">
              <NavLink to={process.env.PUBLIC_URL + "/"}>
              <span className="breadcrum-page-name ">
                  Home
                </span>
              </NavLink>
              <RightOutlined />
              <NavLink to={process.env.PUBLIC_URL + pathname}>
                <h1 className="breadcrum-page-name ">
                  Shop
                </h1>
              </NavLink>
              {
                persistedFilters?.search_filter?.category_ids && (
                  <>
                    <RightOutlined />
                    <div className="breadcrum-category">
                    {mapCategoryTreeData().length > 10 
                      ? mapCategoryTreeData().slice(0, 10) + "..." 
                      : mapCategoryTreeData()}
                  </div>

                  </>
                )
              }

            </div>
            <Row>
              {sidebarFilter == "inActive" ? null : (
                <Col
                  className="order-2 order-lg-1 sidebar"
                  lg={5}
                  md={5}
                  xl={5}
                >
                  {/* shop sidebar */}
                  <ShopSidebar
                    filters={filters}
                    setFilter={setFilter}
                    getLayout={getLayout}
                    products={products}
                    loading={loading}
                    getSortParams={getSortParams}
                    setSidebarFilter={setSidebarFilter}
                    onDescriptionChange={handleDescriptionChange}
                    selectedBrands={selectedBrands}
                    setSelectedBrands={setSelectedBrands}
                    searchTag={searchTag}
                    setSearchTag={setSearchTag}
                    scrollToTop = {scrollToTop}
                    setScrollToTop = {setScrollToTop}
                  />
                </Col>
              )}
              <Col
                className="order-1 order-lg-2 shop-page-margin"
                style={{
                  width: sidebarFilter === "inActive" ? "100%" : "1325px",
                  paddingLeft: sidebarFilter !== "inActive" ? "8px" : "0",
                }}
                lg={sidebarFilter == "inActive" ? 24 : 19}
                xl={sidebarFilter == "inActive" ? 24 : 19}
                md={sidebarFilter == "inActive" ? 24 : 19}
              >
                {/* shop topbar default */}
                <ShopTopbar
                  filters={filters}
                  setFilter={setFilter}
                  getLayout={getLayout}
                  layout={layout}
                  getSidebarFilter={getSidebarFilter}
                  sidebarFilter={sidebarFilter}
                  getFilterSortParams={getFilterSortParams}
                  productCount={totalCount}
                  sortedProductCount={pageSize}
                  getItemsPerPage={getItemsPerPage}
                  getSortParams={getSortParams}
                  searchTag={searchTag}
                  setSearchTag={setSearchTag}
                  setSelectedBrands={setSelectedBrands}
                  selectedBrands={selectedBrands}
                  mapCategoryTreeData={mapCategoryTreeData}
                />

                <div className="text-center mt-10">
                  <ShopProducts
                    layout={layout}
                    products={currentData}
                    sidebarFilter={sidebarFilter}
                    loading={loading}
                    setScrollToTop = {setScrollToTop}
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {!loading && pageSize > index && (
                      <Pagination
                        className="pagination-style"
                        current={+pageNumber || currentPage}
                        pageSize={itemsPerPage}
                        responsive
                        hideOnSinglePage
                        total={totalCount}
                        onChange={handlePaginationChange}
                      />
                    )}
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
            <Col className="category-description">
              <>
                {description && (
                  <>
                    <div className="category-description-heading">Category Description</div>
                    <div dangerouslySetInnerHTML={{ __html: description }} />
                  </>
                )}
              </>
            </Col>

            </Row>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

ShopGridStandard.propTypes = {
  categoryTreeData: PropTypes.array,
  brandsData: PropTypes.array,
  settingData: PropTypes.object,
  location: PropTypes.object,
  products: PropTypes.array,
  productSearch: PropTypes.string,
  pageSize: PropTypes.number,
  totalCount: PropTypes.number,
  setSidebarFilter: PropTypes.func
};

const mapStateToProps = (state) => {
  return {
    categoryTreeData: state.categoryData.entities,
    brandsData: state.brandsData.entities,
    products: state.productData.products,
    productSearch: state.productData.search_key,
    pageSize: state.productData.pageSize,
    totalCount: state.productData.totalCount,
    settingData: state.settingData.ecom.basic,
    loading: state.productData.loading,
  };
};

export default connect(mapStateToProps)(ShopGridStandard);
